export const list = [
  { id: 1, name: "Professional Amount"},
  { id: 2, name: "Coaching Amount" },
  { id: 3, name: "Pay It Forward Suggested Amount" },
  
];

